import { IdObject } from '../../_shared/models/basicDto';
import { Address } from '../../address/models/address';
import { OrganizationDto } from './organization';

export interface SubscriptionListDto extends IdObject<number> {
  OrganizationId: number | null;
  SubscriptionTypeId: number | null;
  StatusID: number | null;
  ContactFirstName: string;
  ContactLastName: string;
  AddressID: number | null;
  FacturationAddressId: number | null;
  SubscriptionModuleId: number | null;
  CreationDate: Date | null;
  Reference: string;
  ToPay: number | null;
  EndDate: Date | null;
  StartDate: Date | null;
  MailCounter: number | null;
  Code: string;
  Klantnummer: string;
  Heardof: number | null;
  FromWho: string;
  FromSub: string;
  FriendDiscount: boolean | null;
  OwnReduction: boolean | null;
  Reduction: number | null;
  ReductionReason: string;
  OwnPrice: number | null;
  NoReduction: boolean | null;
  IsTemporaryPlus: boolean | null;
  DowngradeDate: Date | null;
  ReceivedDowngradeMail1: boolean | null;
  ReceivedDowngradeMail2: boolean | null;
  CustomerThrough: string;
  ProefMailsSent: number | null;
  StatutenPayed: boolean | null;
  HasBtwModule: boolean;
  GoalPlannerPayed: boolean | null;
  CanRenew: boolean;
  IsActive: boolean;
}

export interface SubscriptionDto extends SubscriptionListDto {
  Organization: OrganizationDto;
  FacturationAddress: Address;
  SubscriptionStatus: SubscriptionStatusDto;
  SubscriptionType: SubscriptionTypeDto;
  IsActive: boolean;
  CanRenew: boolean;
  RenewStartDate: Date;
  RenewEndDate: Date;
}

export interface SubscriptionStatusDto {
  Id: number;
  Name: string;
  IsActive: boolean | null;
  Abbreviation: string;
  sortorder: number | null;
}

export interface SubscriptionTypeDto {
  Id: number;
  Name: string;
  Price: number | null;
  PriceMember: number | null;
  Active: boolean | null;
}

export enum SubscriptionTypeEnum {
  Plus = 1,
  Start = 4,
  FREE = 5,
}
